import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { InputObservable, connectState } from '@y42/angular/util';
import { TriggeredByType } from '@y42/json-schema';
import { Observable, map } from 'rxjs';
import { AbstractJobCreatorResolverService } from '../../api/job-creator-resolver.service';
import { JobTriggeredBy } from '../../state/job.model';

@UntilDestroy()
@Component({
  selector: 'y42-job-triggered-by-user-avatar[triggeredBy]',
  templateUrl: './job-triggered-by-user-avatar.component.html',
  styleUrls: ['./job-triggered-by-user-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobTriggeredByUserAvatarComponent {
  constructor(private readonly jobCreatorResolverService: AbstractJobCreatorResolverService) {}

  readonly TriggeredByType = TriggeredByType;

  @Input()
  @InputObservable()
  triggeredBy!: JobTriggeredBy;
  triggeredBy$!: Observable<JobTriggeredBy | undefined>;

  @Input() clickable = false;
  @Input() showNonUserLabel = false;
  @Input() sizePx = 15;

  readonly state = connectState(this, {
    canShowCreator: this.triggeredBy$.pipe(
      map((triggeredBy) => triggeredBy && this.jobCreatorResolverService.canResolve(triggeredBy)),
    ),
  });

  showCreator() {
    if (this.clickable && this.state.canShowCreator) {
      this.jobCreatorResolverService.resolve(this.triggeredBy);
    }
  }
}
